// extracted by mini-css-extract-plugin
export default {"snackBarWrapper":"snackbar_snackBarWrapper__gmp7V","relative":"snackbar_relative__dynNQ","absolute":"snackbar_absolute__N13HF"};